/**
 * @param str
 * @returns {string}
 */
const removeLastCharacterStringUtil = (str) => {
  str = str || ''
  return str.slice(0, -1)
}

export default removeLastCharacterStringUtil
